import { useNavigate } from 'react-router-dom'

import { ASSIGNMENT_STEPS_LIST } from './assignmentLib'

const useAssignmentStepNavigation = () => {
  const navigate = useNavigate()

  const goToStep = async (sessionId, stepId) => {
    const step = ASSIGNMENT_STEPS_LIST[stepId]
    navigate(`/assignment/${sessionId}/${step}`)
  }

  return {
    goToStep,
  }
}

export default useAssignmentStepNavigation
